import { Injectable, EventEmitter, Output, Directive } from '@angular/core';

@Directive()
@Injectable()
export class OverlayService {
  @Output() overlayMessage: EventEmitter<{message: string, redirect: string, persist: boolean}> = new EventEmitter();

  constructor() {
  }

  public displayOverlay(message: string = '', redirect: string = '', persist: boolean = false) {
    this.overlayMessage.emit({message, redirect, persist});
  }

}
